import Vue from 'vue'

const getDefaultState = () => {
    return {
        serviceSettings: {
            id: 0
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("common/service-settings/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listServiceSettings = result.data.result;

                return listServiceSettings;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list job settings: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`common/service-settings/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get job settings`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get job settings: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, permitRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`common/service-settings/create-update`, permitRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Register updated with success!";

                if (permitRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    id: result.data.result,
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async Delete(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.delete(`common/service-settings/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return {
                    success: true,
                    message: "Register deleted with success!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to delete the register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to delete the register: [${error}]`
                };
            }
        }
    },
    
    async ListLevels() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`common/service-settings/list-levels`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listLevels = result.data.result;

                return listLevels;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list levels: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.permit, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.permit;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
